export const GenderPronoun = {
  None: 'none',
  HeHim: 'he_him',
  SheHer: 'she_her',
  TheyThem: 'they_them',
} as const;
export type GenderPronoun = (typeof GenderPronoun)[keyof typeof GenderPronoun];

export const TreatmentPronoun = {
  None: 'none',
  Miss: 'miss',
  Mr: 'mr',
  Ms: 'ms',
  Mrs: 'mrs',
} as const;
export type TreatmentPronoun = (typeof TreatmentPronoun)[keyof typeof TreatmentPronoun];
